"use strict";

define('controller/meeting/detail',['require','exports','module','underscore','backbone','marionette','handlebars','moment','controller/base','config','templates','libs/route.helper','appkit/changes.helper','appkit/loader.helper','libs/bind.helper','libs/table.group.helper','libs/format/date','libs/format/empty','langs','model/meeting','model/document','model/document.decision','model/board','model/agenda.message.template','model/message.tag','model/docstore','model/study','view/page.list','uikit/uikit','view/text.editor','view/html.viewer','view/table.ellipsis','view/table.selected.remove','view/decision.header','backbone.radio'],function (require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Mn = require('marionette');
  var Handlebars = require('handlebars');
  var moment = require('moment');
  var RegionController = require('controller/base');
  var config = require('config');
  var Templates = require('templates');
  var RouteHelper = require('libs/route.helper');
  var ChangesHelper = require('appkit/changes.helper');
  var LoaderHelper = require('appkit/loader.helper');
  var BindHelper = require('libs/bind.helper');
  var TableGroupHelper = require('libs/table.group.helper');
  var DateFormatter = require('libs/format/date');
  var EmptyFormatter = require('libs/format/empty');
  var langs = require('langs');
  var MeetingModel = require('model/meeting');
  var Document = require('model/document');
  var DocumentDecision = require('model/document.decision');
  var BoardModel = require('model/board');
  var AgendaMessageTemplate = require('model/agenda.message.template');
  var MessageTag = require('model/message.tag');
  var DocStore = require('model/docstore');
  var Study = require('model/study');
  var PageList = require('view/page.list');
  var UIKit = require('uikit/uikit');
  var TextEditorView = require('view/text.editor');
  var HtmlViewer = require('view/html.viewer');
  var TableEllipsis = require('view/table.ellipsis');
  var TableSelectedRemove = require('view/table.selected.remove');
  var DecisionHeaderView = require('view/decision.header');
  var EditableField = UIKit.EditableField;
  var Radio = require('backbone.radio');
  var AppChannel = Radio.channel('global');
  var RootView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    template: Templates.IRB['meeting.detail'],
    useInjector: true,
    ui: {
      boardNavigationButtons: '.board-navigation-buttons',
      tabSegment: '.meeting-tab-segment'
    },
    options: {
      useHeader: true,
      hideHeaderFromScreens: true,
      headerText: langs.phrase('Meetings.Details.Title')
    },
    forceUpdate: {
      headerText: true
    },
    internalViewOptions: {
      previousMeetingButton: {
        labeled: true,
        basic: true,
        icon: 'arrow left',
        text: langs.phrase('Meetings.Details.BoardNav.PreviousButton.Text'),
        role: 'menuitem'
      },
      nextMeetingButton: {
        labeled: true,
        basic: true,
        icon: 'arrow right',
        iconRight: true,
        floated: 'right',
        text: langs.phrase('Meetings.Details.BoardNav.NextButton.Text'),
        role: 'menuitem'
      },
      boardName: {
        attributes: {
          role: 'heading',
          'aria-level': '2'
        }
      }
    }
  });
  var ContainerPlaceholder = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    template: false
  });
  var MeetingDetailController = RegionController.extend({
    header: langs.phrase('App.Title'),
    authorities: function authorities() {
      if (!this.state.get('meetingId')) {
        return ['PERM_CREATE_MEETING'];
      } else {
        return ['PERM_VIEW_MEETING'];
      }
    },
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state,
        self = this;
      var root = new RootView(),
        meetingService = app.service('meeting'),
        meeting = new MeetingModel({
          id: state.get('meetingId')
        }),
        submission = new Document({
          id: state.get('documentId')
        }),
        attachments = DocStore.createCollection(DocStore.MEETING_ATTACHMENT_URL),
        boards = BoardModel.all({
          active: true
        }),
        removedPersons = new Backbone.Collection(),
        removedDocuments = new Backbone.Collection(),
        meetingLoaderHelper = new LoaderHelper([meeting], {
          delay: 0
        }),
        attachmentsLoaderHelper = new LoaderHelper([attachments], {
          delay: 0
        }),
        boardMembers = null,
        pageModel = new Backbone.Model(),
        changesHelper = new ChangesHelper().add(meeting),
        unsavedModalEvents = app.request('modal', {
          type: 'UNSAVED_CHANGES',
          state: changesHelper
        }, {
          ariaControlsId: 'meetingDetails'
        }),
        meetingEditForm = root.meetingEditForm,
        agendaForm = root.agendaForm,
        notesForm = root.notesForm,
        attendeeTable = new UIKit.Table(),
        attachmentPageList = new PageList({
          search: true,
          visualsearch: false,
          header: false,
          searchSegmentColor: 'basic',
          searchSegmentAttached: '',
          useTableHeader: true,
          tableHeaderText: langs.phrase('Meetings.Details.Tabs.Attachments.Title'),
          tableHeaderLevel: '2'
        }).on('render', function () {
          this.searchView.$el.parent().css({
            borderTop: '0'
          });
        }),
        fullBoardTable = new UIKit.Table(),
        fullExpeditedTable = new UIKit.Table(),
        expeditedTable = new UIKit.Table(),
        exemptTable = new UIKit.Table(),
        closureTable = new UIKit.Table(),
        topButtonSegment = new ContainerPlaceholder().render(),
        botttTabSegment = new ContainerPlaceholder().render(),
        exemptDocuments = Document.exemptDocumentsByMeetingId(meeting.id),
        expeditedDocuments = Document.expeditedDocumentsByMeetingId(meeting.id),
        fullExpeditedDocuments = Document.fullExpeditedDocumentsByMeetingId(meeting.id),
        closureDocuments = Document.closureDocumentsByMeetingId(meeting.id),
        toolbar = root.toolbar,
        actions = root.actions,
        tabs = root.tabs,
        addAttendeeButton = null,
        undoRemovePersonButton = null,
        undoRemoveSubmissionButton = null,
        addSubmissionButton = null,
        editButton = null,
        deleteButton = null,
        saveButton = null,
        exportButton = null,
        cancelButton = null,
        moreDropdown = null,
        addAttachmentButton = null,
        errorMessages = root.errorMessages,
        tableGroupSort = TableGroupHelper.sortByText(),
        dateFormat = DateFormatter('MMM DD, YYYY', '--'),
        timeFormat = DateFormatter('LT', '--');
      attachmentPageList.searchView.transparent = true;
      attachmentPageList.searchView.model = attachmentsLoaderHelper;
      attachmentPageList.searchView.bindings.loading = 'loading';
      this.root = root;
      this.addDimmerToRequest(meeting);
      addAttendeeButton = new UIKit.Button({
        text: "Add",
        color: 'secondary',
        size: "small",
        compact: true,
        icon: "plus",
        name: '_test',
        attributes: {
          role: 'button',
          'aria-label': langs.phrase('Meetings.Details.Tabs.Attendees.AddButton.ARIALabel')
        }
      });
      addAttachmentButton = new UIKit.Button({
        text: "Add",
        color: 'secondary',
        size: "small",
        compact: true,
        icon: "plus",
        attributes: {
          role: 'button',
          'aria-label': langs.phrase('Meetings.Details.Tabs.Attachments.AddButton.ARIALabel')
        }
      });
      addSubmissionButton = new UIKit.Button({
        text: "Add",
        color: 'secondary',
        size: "small",
        compact: true,
        icon: "plus",
        attributes: {
          role: 'button',
          'aria-label': langs.phrase('Meetings.Details.Tabs.FullBoardReviews.AddButton.ARIALabel')
        }
      });
      deleteButton = new UIKit.Button({
        text: 'Delete',
        icon: 'trash',
        attributes: {
          role: 'button',
          'aria-label': langs.phrase('Meetings.Details.DeleteButton.ARIALabel')
        }
      });
      editButton = new UIKit.Button({
        text: 'Edit',
        icon: 'pencil',
        attributes: {
          role: 'button',
          'aria-label': langs.phrase('Meetings.Details.EditButton.ARIALabel')
        }
      });
      undoRemovePersonButton = new UIKit.Button({
        text: 'Undo',
        icon: 'undo',
        size: 'small',
        compact: true,
        disabled: true,
        attributes: {
          role: 'button',
          'aria-label': langs.phrase('Meetings.Details.Tabs.Attendees.UndoButton.ARIALabel')
        }
      });
      undoRemoveSubmissionButton = new UIKit.Button({
        text: 'Undo',
        icon: 'undo',
        size: 'small',
        compact: true,
        disabled: true,
        attributes: {
          role: 'button',
          'aria-label': langs.phrase('Meetings.Details.Tabs.FullBoardReviews.UndoButton.ARIALabel')
        }
      });
      exportButton = new UIKit.Button({
        text: 'Export'
      });
      root.$el.css(config.contentCss);
      actions.$el.addClass('clearfix');
      addAttendeeButton.$el.css('margin-right', '0');
      addSubmissionButton.$el.css('margin-right', '0');
      var finalizedStatus = new UIKit.Text({});
      finalizedStatus.$el.css({
        opacity: '0.5'
      });
      root.status.visible = false;
      root.status.$el.attr('class', 'ui basic segment fitted right floated right aligned').css({
        'margin-right': 0,
        'font-size': '12px'
      });
      root.status.add(new UIKit.Text({
        tagName: 'b',
        text: 'Minutes Approved'
      })).add(new UIKit.Text({
        tagName: 'br'
      })).add(finalizedStatus);
      meetingEditForm.addField({
        text: 'Board',
        width: 16,
        required: true
      }, new UIKit.Dropdown({
        name: 'boardDropdown',
        search: true
      })).getOption('parent').addGroup({
        autoSize: true
      }).addField({
        text: 'Meeting Date',
        required: true
      }, new UIKit.InputDate({
        name: 'meetingDate'
      })).getOption('parent').addField({
        text: 'Start Time'
      }, new UIKit.InputTime({
        name: 'startTime'
      })).getOption('parent').getOption('parent').addGroup({
        autoSize: true
      }).addField({
        text: 'Location',
        required: true
      }, new UIKit.Input({
        name: 'location'
      })).getOption('parent').addField({
        text: 'End Time'
      }, new UIKit.InputTime({
        name: 'endTime'
      })).getOption('parent').getOption('parent');
      var agendaOptions = _.extend({}, config.redactorDefaults, {
        minHeight: 150,
        name: 'editAgenda'
      });
      agendaForm.addField({}, new TextEditorView(agendaOptions)).getOption('parent').addField({}, new HtmlViewer({
        name: 'agenda',
        model: meeting,
        bindings: {
          text: 'agenda'
        }
      }));
      var notesOptions = _.extend({}, config.redactorDefaults, {
          minHeight: 150,
          name: 'editNotes'
        }),
        viewNotes = new UIKit.Form.Field({}),
        changeNotes = new EditableField({
          model: meeting,
          active: true,
          input: new TextEditorView(_.extend({}, notesOptions, {
            name: 'editNotes2'
          })),
          valueBinding: 'notes',
          visible: false
        });
      viewNotes.add(new HtmlViewer({
        name: 'notes',
        model: meeting,
        bindings: {
          text: 'notes'
        }
      }));
      changeNotes.textView.formatter = function (text) {
        return text ? text : '<span style="opacity: 0.5">--</span>';
      };
      notesForm.addField({}, new TextEditorView(notesOptions)).getOption('parent').add(viewNotes).add(changeNotes);
      root.listenTo(changeNotes, 'confirm', function () {
        meeting.updateNotes();
      });
      var DimmerContainer = UIKit.Container.extend({
        className: 'ui basic fitted segment',
        template: Templates.IRB['meeting.detail.tabs.dimmer.container'],
        options: _.extend({}, UIKit.Container.prototype.options, {
          tableHeaderText: ''
        }),
        showLoading: function showLoading() {
          var el = this.$el;
          el.addClass('loading');
          return function () {
            el.removeClass('loading');
          };
        }
      });
      function createTableDimmer(table, tableHeaderText) {
        return new DimmerContainer({
          tableHeaderText: tableHeaderText
        }).add(table);
      }
      function showTableLoading(table) {
        return table.getOption('parent').showLoading();
      }
      function syncDefaultBoardToMeeting() {
        if (state.get('boardId')) {
          meeting.set('group', boards.get(state.get('boardId')));
        }
      }
      tabs.tabListAriaLabel = langs.phrase('Meetings.Details.Tabs.ARIALabel');
      tabs.add('Attendees', createTableDimmer(attendeeTable, langs.phrase('Meetings.Details.Tabs.Attendees.Title'))).add('Attachments', attachmentPageList, function (tab) {
        tab.$el.css('border', '0');
      }).add('Full Board Reviews', createTableDimmer(fullBoardTable, langs.phrase('Meetings.Details.Tabs.FullBoardReviews.Title'))).add('Full Expedited Reviews', createTableDimmer(fullExpeditedTable, langs.phrase('Meetings.Details.Tabs.FullExpeditedReviews.Title'))).add('Expedited Reviews', createTableDimmer(expeditedTable, langs.phrase('Meetings.Details.Tabs.ExpeditedReviews.Title'))).add('Exempt Reviews', createTableDimmer(exemptTable, langs.phrase('Meetings.Details.Tabs.ExemptReviews.Title'))).add('Closures', createTableDimmer(closureTable, langs.phrase('Meetings.Details.Tabs.Closures.Title')));
      tabs.each(function (view, index) {
        view.$el.css('border-top', 'none');
        view.$el.addClass('basic fitted');
        view.$el.css('margin-bottom', '0');
      });
      var EDIT_ACTIONS = [saveButton = new UIKit.Button({
        text: 'Save',
        icon: 'save',
        color: 'primary',
        disabled: true,
        floated: 'right'
      }), cancelButton = new UIKit.Button({
        text: 'Cancel',
        floated: 'right'
      })];
      var EDIT_VIEWS = [meetingEditForm, notesForm.editNotes, agendaForm.editAgenda].concat(EDIT_ACTIONS);
      var VIEW_VIEWS = [root.boardName, root.boardTime, root.boardDate, root.boardLocation, agendaForm.agenda, notesForm.notes];
      toolbar.add(editButton).add(deleteButton);
      _.each(EDIT_ACTIONS, function (btn) {
        actions.add(btn);
      });
      root.boardLocation.model = meeting;
      root.boardLocation.bindings.text = 'location';
      root.boardName.model = meeting;
      root.boardName.bindings.text = 'boardName';
      meeting.labels.group = 'Board';
      addSubmissionButton.disabled = true;
      meetingEditForm.model = meeting;
      meetingEditForm.bindings.boardDropdown = 'group';
      meetingEditForm.bindings.location = 'location';
      meetingEditForm.boardDropdown.collection = boards;
      meetingEditForm.boardDropdown.childBindings = {
        text: 'name'
      };
      agendaForm.model = meeting;
      agendaForm.bindings.editAgenda = 'agenda';
      notesForm.model = meeting;
      notesForm.bindings.editNotes = 'notes';
      saveButton.model = meetingLoaderHelper;
      saveButton.bindings.loading = 'loading';
      errorMessages.childBindings.text = 'text';
      errorMessages.collection = new Backbone.Collection();
      attendeeTable.collection = meeting.get('people');
      attendeeTable.emptyText = 'No attendees.';
      attendeeTable.selectable = true;
      attendeeTable.tabletStackable = true;
      fullBoardTable.emptyText = 'No submissions.';
      fullExpeditedTable.emptyText = 'No submissions.';
      expeditedTable.emptyText = 'No submissions.';
      exemptTable.emptyText = 'No submissions.';
      closureTable.emptyText = 'No submissions.';
      attendeeTable.ariaLabel = langs.phrase('Meetings.Details.Tabs.Attendees.Title');
      fullBoardTable.ariaLabel = langs.phrase('Meetings.Details.Tabs.FullBoardReviews.Title');
      fullExpeditedTable.ariaLabel = langs.phrase('Meetings.Details.Tabs.FullExpeditedReviews.Title');
      expeditedTable.ariaLabel = langs.phrase('Meetings.Details.Tabs.ExpeditedReviews.Title');
      exemptTable.ariaLabel = langs.phrase('Meetings.Details.Tabs.ExemptReviews.Title');
      closureTable.ariaLabel = langs.phrase('Meetings.Details.Tabs.Closures.Title');
      attendeeTable.collection = new TableGroupHelper(meeting.get('people')).sort(function (groups) {
        var sortedGroups = [],
          members = _.find(groups, function (g) {
            return g.get('key') == 'Members';
          }),
          alternates = _.find(groups, function (g) {
            return g.get('key') == 'Alternates';
          });
        if (members) {
          groups.splice(groups.indexOf(members), 1);
          sortedGroups.push(members);
        }
        if (alternates) {
          groups.splice(groups.indexOf(alternates), 1);
          sortedGroups.push(alternates);
        }
        sortedGroups = sortedGroups.concat(groups);
        return sortedGroups;
      }).key(function (model) {
        return (String(model.get('membership')).trim() || 'Guest') + 's';
      }).collection();
      fullBoardTable.collection = new TableGroupHelper(meeting.get('documents')).sort(tableGroupSort).key('templateType').collection();
      fullExpeditedTable.collection = new TableGroupHelper(fullExpeditedDocuments).sort(tableGroupSort).key('templateType').collection();
      expeditedTable.collection = new TableGroupHelper(expeditedDocuments).sort(tableGroupSort).key('templateType').collection();
      exemptTable.collection = new TableGroupHelper(exemptDocuments).sort(tableGroupSort).key('templateType').collection();
      closureTable.collection = closureDocuments;
      _.each([attendeeTable, fullBoardTable, fullExpeditedTable, expeditedTable, exemptTable, closureTable], function (table, index) {
        table.sortable = false;
        table.basic = true;
        table.selection = 'single';
        table.selectable = true;
        table.borderless = true;
        table.invertColumnChildViewsOnActive = true;
      });
      if (state.has('documentId')) {
        var study = new Study();
        submission.fetch();
        var bc = root.breadcrumb.collection = new Backbone.Collection([{
          text: 'Studies',
          link: RouteHelper.createLink('study:list')
        }, {
          text: 'Study Details'
        }, {
          text: 'Submission Details'
        }, {
          text: app.title
        }]);
        new BindHelper(new RouteHelper('study:detail').add(submission, {
          studyId: 'studyId'
        }), bc.at(1)).bind('link').listenTo(root, 'destroy', function () {
          this.stopListening().off();
        });
        new BindHelper(new RouteHelper('submission:detail').add(submission, {
          studyId: 'studyId',
          documentId: 'id'
        }), bc.at(2)).bind('link').listenTo(root, 'destroy', function () {
          this.stopListening().off();
        });
        root.listenToOnce(submission, 'sync', function () {
          study.set('id', submission.get('studyId')).fetch();
        }).listenTo(study, 'sync', function () {
          var isArchived = !!study.get('finalizedDate');
          bc.at(0).set({
            link: RouteHelper.resolve('study:list', {
              type: isArchived ? 'archive' : 'active'
            })
          });
        });
      } else {
        updateBreadcrumb();
      }
      function getMeetingLinkState() {
        var startDate = moment(meeting.get('startDate'));
        return new Backbone.Model({
          tab: 'month',
          month: startDate.month(),
          year: startDate.year(),
          date: +startDate
        });
      }
      function updateBreadcrumb() {
        if (!state.has('documentId')) {
          root.breadcrumb.collection = new Backbone.Collection([{
            text: langs.phrase('Meetings.Calendar.Title'),
            link: RouteHelper.createLink('meeting:list', getMeetingLinkState())
          }, {
            text: langs.phrase('Meetings.Details.Title')
          }]);
        }
      }
      function setupAttendeeToggle(checkbox, model) {
        if (meeting.get('finalizedDate')) {
          checkbox.disabled = true;
        }
        checkbox.polar = true;
        checkbox.toggle = true;
        checkbox.model = model;
        checkbox.bindings = {
          value: 'present'
        };
        checkbox.listenTo(checkbox.options.rowView, 'double:press', function () {
          if (!meeting.get('finalizedDate')) {
            checkbox.value = !checkbox.value;
          }
        });
      }
      var meetingDocumentDecisionHeaderOptions = {
        bindings: {
          status: 'decision.status',
          date: 'decision.resultDate',
          pending: 'decision.pending'
        }
      };
      var documentDecisionHeaderOptions = {
        bindings: {
          status: 'decision.status',
          date: 'decision.resultDate',
          pending: 'decision.pending'
        }
      };
      attendeeTable.columns.set([{
        text: 'Present',
        childView: UIKit.Checkbox,
        collapsing: true,
        onBeforeAdd: setupAttendeeToggle
      }, {
        text: 'Present',
        collapsing: true,
        align: 'center',
        childView: UIKit.Text,
        onBeforeAdd: setupAttendeeCheck,
        visible: false
      }, {
        text: 'Name',
        data: 'person.boldHtmlDisplayName'
      }, {
        text: 'Status',
        data: 'scientificStatus',
        formatter: EmptyFormatter('--')
      }, {
        text: 'Representation',
        data: 'representation',
        formatter: EmptyFormatter('--')
      }, {
        text: 'Affiliation',
        data: 'affiliation',
        formatter: EmptyFormatter('--')
      }, {
        text: 'Office',
        data: 'office',
        formatter: EmptyFormatter('--')
      }, {
        childView: TableSelectedRemove,
        align: 'right',
        collapsing: true,
        view: new UIKit.Container().add(undoRemovePersonButton).add(addAttendeeButton)
      }]);
      attachmentPageList.setupCollection(attachments).setupColumns([{
        name: 'attachment:ellipsis',
        text: 'Manage',
        useAccessibilityText: true,
        childView: TableEllipsis,
        childViewOptions: {
          ariaLabel: 'manage attachment'
        },
        collapsing: true
      }, {
        text: 'Filename',
        data: 'fileName'
      }, {
        text: 'Uploader',
        data: 'createPerson.displayName',
        sortable: true,
        sort: 'createPerson.lastName'
      }, {
        text: 'Date Uploaded',
        data: 'createDate',
        formatter: DateFormatter('L LT'),
        colspan: 2,
        sortable: true
      }, {
        collapsing: true,
        view: addAttachmentButton
      }]).setupPaginate().setupPageSizes().setupTableSort().setupLoading().setupSearch('').spfHelper.setupAutoFetch().setSortField('createDate').setSortDirection('ascending').setPaginateSize(10);
      var attachmentTable = attachmentPageList.table;
      root.attachmentTable = attachmentTable;
      attachmentTable.selectable = true;
      attachmentTable.focusable = true;
      fullBoardTable.columns.set([{
        childView: TableEllipsis,
        childViewOptions: {
          ariaLabel: 'manage review'
        },
        text: 'Manage',
        useAccessibilityText: true,
        collapsing: true,
        onBeforeAdd: setupMeetingDocumentEllipsis
      }, {
        text: 'IRB#',
        data: 'studyLabel'
      }, {
        text: 'Title',
        data: 'studyTitle'
      }, {
        text: 'PI',
        data: 'principalInvestigator',
        formatter: EmptyFormatter('--')
      }, {
        text: 'Primary',
        data: 'primaryReviewer',
        formatter: EmptyFormatter('--')
      }, {
        text: 'Secondary',
        data: 'secondaryReviewer',
        formatter: EmptyFormatter('--')
      }, {
        text: 'Decision',
        childView: DecisionHeaderView,
        childViewOptions: meetingDocumentDecisionHeaderOptions,
        colspan: 2
      }, {
        view: new UIKit.Container().add(undoRemoveSubmissionButton).add(addSubmissionButton),
        collapsing: true
      }]);
      fullExpeditedTable.columns.set([{
        text: 'Manage',
        useAccessibilityText: true,
        childView: TableEllipsis,
        childViewOptions: {
          ariaLabel: 'manage review'
        },
        collapsing: true,
        onBeforeAdd: setupDocumentEllipsis
      }, {
        text: 'IRB#',
        data: 'studyLabel'
      }, {
        text: 'Title',
        data: 'studyTitle'
      }, {
        text: 'PI',
        data: 'principalInvestigator',
        formatter: EmptyFormatter('--')
      }, {
        text: 'Decision',
        childView: DecisionHeaderView,
        childViewOptions: documentDecisionHeaderOptions
      }]);
      expeditedTable.columns.set([{
        text: 'Manage',
        useAccessibilityText: true,
        childView: TableEllipsis,
        childViewOptions: {
          ariaLabel: 'manage review'
        },
        collapsing: true,
        onBeforeAdd: setupDocumentEllipsis
      }, {
        text: 'IRB#',
        data: 'studyLabel'
      }, {
        text: 'Title',
        data: 'studyTitle'
      }, {
        text: 'PI',
        data: 'principalInvestigator',
        formatter: EmptyFormatter('--')
      }, {
        text: 'Decision',
        childView: DecisionHeaderView,
        childViewOptions: documentDecisionHeaderOptions
      }]);
      exemptTable.columns.set([{
        text: 'Manage',
        useAccessibilityText: true,
        childView: TableEllipsis,
        childViewOptions: {
          ariaLabel: 'manage review'
        },
        collapsing: true,
        onBeforeAdd: setupDocumentEllipsis
      }, {
        text: 'IRB#',
        data: 'studyLabel'
      }, {
        text: 'Title',
        data: 'studyTitle'
      }, {
        text: 'PI',
        data: 'principalInvestigator',
        formatter: EmptyFormatter('--')
      }, {
        text: 'Decision',
        childView: DecisionHeaderView,
        childViewOptions: documentDecisionHeaderOptions
      }]);
      closureTable.columns.set([{
        text: 'Manage',
        useAccessibilityText: true,
        childView: TableEllipsis,
        childViewOptions: {
          ariaLabel: 'manage closure'
        },
        collapsing: true,
        onBeforeAdd: setupDocumentEllipsis
      }, {
        text: 'IRB#',
        data: 'studyLabel'
      }, {
        text: 'Title',
        data: 'studyTitle'
      }, {
        text: 'PI',
        data: 'principalInvestigator',
        formatter: EmptyFormatter('--')
      }, {
        text: 'Closed Date',
        data: 'finalizedDate',
        formatter: dateFormat
      }]);
      function createDocumentLink(doc) {
        return RouteHelper.createLink('submission:detail', doc, {
          documentId: 'id',
          studyId: 'studyId'
        });
      }
      ;
      function createDecisionsLink(doc, meeting) {
        return RouteHelper.resolve('decision:make', {
          id: doc.id,
          meetingId: meeting.id
        });
      }
      ;
      function updateAttendeeCheckIcon(view, model) {
        if (model.get('present')) {
          view.text = new Handlebars.SafeString('<i class="icon checkmark"></i>');
        } else {
          view.text = '';
        }
      }
      ;
      function setupAttendeeCheck(view, model) {
        view.listenTo(model, 'change:present', function () {
          updateAttendeeCheckIcon(view, model);
        });
        updateAttendeeCheckIcon(view, model);
      }
      ;
      function setupMeetingDocumentEllipsis(view, doc) {
        var decision = doc.get('decision');
        view.collection = new Backbone.Collection([{
          text: 'Results',
          action: 'results',
          icon: 'legal',
          visible: false
        }, {
          text: 'View',
          icon: 'eye',
          link: createDocumentLink(doc)
        }, {
          text: 'Remove',
          icon: 'remove',
          action: 'remove',
          visible: !!pageModel.get('canEdit')
        }]);
        var removeModel = view.collection.last(),
          resultsModel = view.collection.at(0);
        view.listenTo(pageModel, 'change:canEdit', function () {
          removeModel.set('visible', !!pageModel.get('canEdit'));
        });
        if (decision) {
          resultsModel.set('visible', true);
        }
        view.childBindings.link = 'link';
        view.childBindings.icon = 'icon';
        view.childBindings.text = 'text';
        view.childBindings.visible = 'visible';
        view.on('action', _.partial(onDocumentAction, doc));
      }
      ;
      function setupDocumentEllipsis(view, model) {
        var doc = model;
        view.collection = new Backbone.Collection([{
          text: 'Results',
          icon: 'legal',
          action: 'results'
        }, {
          text: 'View',
          icon: 'eye',
          link: createDocumentLink(doc)
        }]);
        if (!doc.get('decision')) {
          view.collection.remove(view.collection.at(0));
        }
        view.childBindings.link = 'link';
        view.childBindings.icon = 'icon';
        view.childBindings.text = 'text';
      }
      ;
      function onDocumentAction(doc, view, action) {
        switch (action.get('action')) {
          case 'remove':
            if (fullBoardTable.value === view.model) {
              fullBoardTable.value = null;
            }
            meeting.removeDocument(doc);
            saveMeeting().promise().then(function () {
              removedDocuments.push(doc);
            });
            break;
          case 'results':
            var decision = doc.get('decision');
            if (decision) {
              showDecisionOverlay(doc, true);
            }
            break;
        }
      }
      ;
      function showDecisionOverlay(doc, refreshMeetingOnHide) {
        if (doc.get('decision')) {
          var study = new Study({
            id: doc.get("studyId")
          });
          study.fetch().promise().then(function () {
            var decision = doc.get('decision');
            decision.isDecisionOutdated().success(function (response) {
              decision.study = study;
              decision.isOutdated = response.data;
              var modalRequest = app.request('decisionDetailsOverlay', {
                model: decision,
                allowPermissions: true
              });
              if (refreshMeetingOnHide) {
                modalRequest.once('hidden', function () {
                  meeting.fetch();
                });
              }
            });
          });
        }
      }
      function onChangeEditing() {
        var isEditing = pageModel.get('editing');
        _.each(EDIT_VIEWS, function (btn) {
          btn.visible = isEditing;
        });
        actions.visible = isEditing;
        _.each(VIEW_VIEWS, function (btn) {
          btn.visible = !isEditing;
        });
        exportButton.visible = false;
        addAttendeeButton.disabled = isEditing;
        addSubmissionButton.disabled = isEditing;
        botttTabSegment.visible = !isEditing;
        topButtonSegment.visible = !isEditing;
        toolbar.visible = !isEditing;
      }
      function onChangeCanEdit() {
        var canEdit = !!pageModel.get('canEdit');
        addAttendeeButton.visible = canEdit;
        addSubmissionButton.visible = canEdit;
        undoRemovePersonButton.visible = canEdit;
        undoRemoveSubmissionButton.visible = canEdit;
        editButton.visible = canEdit;
        attendeeTable.selection = canEdit ? 'single' : null;
        attendeeTable.columns.last().set('visible', canEdit);
      }
      ;
      function updateNotesField() {
        if (self.userCanModifyMeeting() && meeting.get('adjournDate')) {
          changeNotes.visible = !meeting.get('finalizedDate');
          viewNotes.visible = !!meeting.get('finalizedDate');
        } else {
          changeNotes.visible = false;
          viewNotes.visible = true;
        }
      }
      ;
      function updateMeetingStatus() {
        var finalizedDate = meeting.get('finalizedDate');
        root.status.visible = !!finalizedDate;
        if (finalizedDate) {
          finalizedStatus.text = meeting.get('finalizedPerson').get('displayName') + ' on ' + moment(finalizedDate).format(config.dateFormat);
        }
      }
      ;
      function updateMeetingStateBtns() {
        var hasModifyPermission = self.userCanModifyMeeting();
        root.startMeeting.visible = !meeting.get('beginDate') && hasModifyPermission;
        root.endMeeting.visible = !meeting.get('adjournDate') && !!meeting.get('beginDate') && hasModifyPermission;
        root.finalizeMeeting.visible = !meeting.get('finalizedDate') && !!meeting.get('adjournDate') && hasModifyPermission;
        root.sendAgenda.visible = !meeting.get('beginDate') && hasModifyPermission;
      }
      function onChangeCanMarkPresent() {
        var canMarkPresent = !!pageModel.get('canMarkPresent');
        attendeeTable.columns.first().set('visible', canMarkPresent);
        attendeeTable.columns.at(1).set('visible', !canMarkPresent);
        attendeeTable.selectable = canMarkPresent && !meeting.get('finalizedDate');
        if (canMarkPresent && !meeting.get('finalizedDate')) {
          attendeeTable.$el.addClass('unselectable');
        } else {
          attendeeTable.$el.removeClass('unselectable');
        }
      }
      ;
      function onChangeCanDelete() {
        var canDelete = !!pageModel.get('canDelete');
        deleteButton.visible = canDelete;
      }
      ;
      function updatePermissions() {
        var canEdit = self.userCanModifyMeeting() && !meeting.get('adjournDate'),
          canMarkPresent = self.userCanModifyMeeting(),
          canDelete = self.userCanDeleteMeeting();
        pageModel.set('canEdit', canEdit);
        pageModel.set('canMarkPresent', canMarkPresent);
        pageModel.trigger('change:canMarkPresent');
        pageModel.set('canDelete', canDelete);
      }
      ;
      function updateDateTime(field, dateInt, timeInt) {
        if (!dateInt || !timeInt) {
          return;
        }
        var time = moment(timeInt);
        meeting.set(field, +moment(dateInt).hour(time.hour()).minute(time.minute()));
      }
      ;
      function updateStartDate() {
        updateDateTime('startDate', meetingEditForm.meetingDate.value, meetingEditForm.startTime.value);
      }
      ;
      function updateEndDate() {
        updateDateTime('endDate', meetingEditForm.meetingDate.value, meetingEditForm.endTime.value);
      }
      ;
      function updateEndTime() {
        var endDate = moment(meeting.get('endDate')),
          startTime = meetingEditForm.startTime.value,
          mStartTime = moment(startTime),
          endTime = +moment().hour(endDate.hour()).minute(endDate.minute()),
          mEndTime = moment(endTime);
        var normalizedStartTime = moment().hour(mStartTime.hour()).minute(mStartTime.minute()),
          normalizedEndTime = moment().hour(mEndTime.hour()).minute(mEndTime.minute());
        if (!endTime || normalizedStartTime.isAfter(normalizedEndTime)) {
          meetingEditForm.endTime.value = +moment(startTime).add(1, 'hour');
        }
      }
      ;
      function saveMeeting() {
        var xhr = meeting.save();
        if (!xhr) {
          return;
        }
        xhr.promise().then(function () {
          pageModel.set('editing', false);
        })["catch"](function (e) {});
        return xhr;
      }
      ;
      function deleteMeeting() {
        app.request('modal', {
          type: 'CONFIRM_DESTROY',
          entity: 'Meeting',
          name: meeting.get('boardName') + ' Meeting'
        }, {
          ariaControlsId: 'meetingDetails'
        }).on('confirm', function () {
          var xhr = meeting.destroy();
          if (!xhr) {
            return;
          }
          xhr.promise().then(function () {
            app.navigate(RouteHelper.createLink('meeting:list', getMeetingLinkState()).slice(1), {
              trigger: true
            });
          })["catch"](function () {});
        });
      }
      ;
      function toggleEditing() {
        pageModel.set('editing', !pageModel.get('editing'));
      }
      ;
      function addPeopleDialog() {
        app.request('personFinderOverlay', {
          ignore: meeting.get('people').pluck('person')
        }).on('save', function (personnel) {
          if (personnel && personnel.length) {
            meeting.addPeople(personnel);
            saveMeeting();
          }
        });
      }
      ;
      function addSubmissionDialog() {
        app.request('boardSubmissionFinderOverlay', {
          ignore: meeting.get('documents').toArray(),
          boardId: meeting.get('group').id
        }).on('save', function (newDocuments) {
          if (newDocuments && newDocuments.length) {
            meeting.addDocuments(newDocuments);
            saveMeeting().promise()["catch"](function (err) {
              meeting.fetch();
            });
          }
        });
      }
      ;
      root.listenTo(editButton, 'press', function () {
        toggleEditing();
      }).listenTo(exportButton, 'press', function () {}).listenTo(undoRemovePersonButton, 'press', function () {
        var person = removedPersons.pop();
        meeting.addPerson(person);
        saveMeeting();
      }).listenTo(undoRemoveSubmissionButton, 'press', function () {
        var doc = removedDocuments.pop();
        meeting.addDocument(doc);
        saveMeeting();
      }).listenTo(saveButton, 'press', function () {
        saveMeeting();
      }).listenTo(deleteButton, 'press', function () {
        deleteMeeting();
      }).listenTo(cancelButton, 'press', function () {
        changesHelper.reset();
        meeting.fetch();
        toggleEditing();
      }).listenTo(addAttendeeButton, 'press', function () {
        addPeopleDialog();
      }).listenTo(addAttachmentButton, 'press', function () {
        function uploadFiles(files) {
          var uploads = DocStore.createUploadCollection(DocStore.MEETING_ATTACHMENT_URL, files).params({
            meetingId: meeting.id
          }).on('upload:complete', function () {
            attachments.fetch();
          });
          app.request('file:upload', uploads);
        }
        app.request('file:chooser', {
          multiple: true,
          callback: uploadFiles
        });
      }).listenTo(attachmentPageList.searchView, 'change:value', _.debounce(function () {
        var value = attachmentPageList.searchView.value,
          spfHelper = attachmentPageList.spfHelper;
        spfHelper.filter.set('q', value);
      })).listenTo(addSubmissionButton, 'press', function () {
        addSubmissionDialog();
      }).listenTo(attendeeTable, 'row:remove:model', _.debounce(function (view) {
        var person = view.model.get('person');
        if (attendeeTable.value == view.model) {
          attendeeTable.value = null;
        }
        meeting.removePerson(person);
        saveMeeting().promise().then(function () {
          removedPersons.push(person);
        })["finally"](showTableLoading(attendeeTable));
      })).listenTo(fullBoardTable, 'row:double:press', function (row) {
        var decision = row.model.get('decision');
        if (decision) {
          showDecisionOverlay(row.model, true);
        }
      }).listenTo(fullExpeditedTable, 'row:double:press', function (row) {
        showDecisionOverlay(row.model);
      }).listenTo(attachmentPageList.table, 'row:before:add:child', function (row, child, model, column) {
        if (column.get('name') === 'attachment:ellipsis') {
          child.view.childBindings.icon = 'icon';
          child.view.childBindings.link = 'link';
          child.view.childBindings.target = 'target';
          child.collection = new Backbone.Collection([{
            icon: 'download',
            text: 'Download',
            link: model.get('url'),
            target: '_blank'
          }]);
          if (self.userCanModifyMeeting()) {
            child.collection.push({
              icon: 'trash',
              text: 'Delete',
              action: 'delete'
            });
          }
        }
      }).listenTo(attachmentPageList.table, 'row:action', function (row, action) {
        var model = row.model;
        switch (action.get('action')) {
          case 'delete':
            model.destroy({
              wait: true
            });
            break;
        }
      }).listenTo(attachmentPageList.table, 'row:double:press', function (row, action) {
        var model = row.model;
        window.open(model.get('url'));
      }).listenTo(fullExpeditedTable, 'row:action', function (row, action) {
        var doc = row.model;
        switch (action.get('action')) {
          case 'results':
            showDecisionOverlay(doc);
            break;
        }
      }).listenTo(expeditedTable, 'row:double:press', function (row) {
        showDecisionOverlay(row.model);
      }).listenTo(expeditedTable, 'row:action', function (row, action) {
        var doc = row.model;
        switch (action.get('action')) {
          case 'results':
            showDecisionOverlay(doc);
            break;
        }
      }).listenTo(exemptTable, 'row:double:press', function (row) {
        showDecisionOverlay(row.model);
      }).listenTo(exemptTable, 'row:action', function (row, action) {
        var doc = row.model;
        switch (action.get('action')) {
          case 'results':
            showDecisionOverlay(doc);
            break;
        }
      }).listenTo(closureTable, 'row:double:press', function (row) {
        var doc = row.model;
        app.navigate(createDocumentLink(row.model).slice(1), {
          trigger: true
        });
      }).listenTo(meetingEditForm.meetingDate, 'change:value', updateStartDate).listenTo(meetingEditForm.meetingDate, 'change:value', updateEndDate).listenTo(meetingEditForm.startTime, 'change:value', updateStartDate).listenTo(meetingEditForm.startTime, 'change:value', updateEndTime).listenTo(meetingEditForm.endTime, 'change:value', updateEndDate);
      root.listenTo(root.startMeeting, 'press', function () {
        app.request('modal', {
          content: 'Are you sure you want to start the meeting? This will finalize the agenda and you will no longer be able to send it.',
          denyBtn: {
            inverted: false
          },
          header: 'Start Meeting',
          type: 'CONFIRM'
        }, {
          basic: false
        }).on('confirm', function () {
          meeting.start();
        });
      }).listenTo(root.endMeeting, 'press', function () {
        app.request('modal', {
          content: 'Are you sure you want to end the meeting?',
          denyBtn: {
            inverted: false
          },
          header: 'End Meeting',
          type: 'CONFIRM'
        }, {
          basic: false
        }).on('confirm', function () {
          meeting.end();
        });
      }).listenTo(root.finalizeMeeting, 'press', function () {
        app.request('modal', {
          content: 'Are you sure you want to approve the minutes ? Minutes will post approval date and time as [' + moment().format('MMM DD, YYYY HH:mm:ss') + ' (' + AppChannel.request('get:setting:model', AppChannel.request('get:config').IRB_TIMEZONE).get('value') + ')] . By approving, the minutes document and all decisions will be finalized and become uneditable.',
          denyBtn: {
            inverted: false
          },
          header: 'Approve Minutes',
          type: 'CONFIRM'
        }, {
          basic: false
        }).on('confirm', function () {
          meeting.finalize().promise().tap(function () {
            attendeeTable.render();
          });
        });
      });
      root.on('render', function () {
        topButtonSegment.setElement(root.ui.boardNavigationButtons);
        botttTabSegment.setElement(root.ui.tabSegment);
      }).listenTo(root.viewAgenda, 'press', function () {
        meetingService.generateAgenda(meeting);
      }).listenTo(root.viewMinutes, 'press', function () {
        meetingService.generateMinutes(meeting);
      }).listenTo(root.sendAgenda, 'press', function () {
        var overlay = app.overlay,
          messageTemplate = new AgendaMessageTemplate({
            'code.name': 'IRB.MEETING.AGENDA',
            'templateType.name': 'Email'
          }),
          tags = MessageTag.allByNotificationKind(null, false),
          tagsAddressable = new Backbone.Collection(),
          changesHelper = new ChangesHelper().add(messageTemplate),
          unsavedChangesModal = app.request('modal', {
            type: 'UNSAVED_CHANGES',
            state: changesHelper
          }, {
            ariaControlsId: 'overlayContainer'
          }),
          accidentalCloseModal = app.request('modal', {
            type: 'UNSAVED_CHANGES'
          }, {
            ariaControlsId: 'overlayContainer'
          }),
          previewButton = new UIKit.Button({
            text: 'Preview',
            color: 'white',
            floated: 'right',
            icon: 'file pdf outline'
          }),
          popup = null;
        var headerText = "Would you like to send the agenda?",
          approveBtnText = "Send",
          approveBtnIcon = "send outline",
          denyBtnText = "Don't Send";
        unsavedChangesModal.content.text = headerText;
        unsavedChangesModal.actions.at(0).text = denyBtnText;
        unsavedChangesModal.actions.at(1).text = approveBtnText;
        unsavedChangesModal.actions.at(1).icon = approveBtnIcon;
        accidentalCloseModal.content.text = headerText;
        accidentalCloseModal.actions.at(0).text = denyBtnText;
        accidentalCloseModal.actions.at(1).text = approveBtnText;
        accidentalCloseModal.actions.at(1).icon = approveBtnIcon;
        changesHelper.set('changes', true);
        overlay.buttonType = 'save';
        overlay.button.text = 'Send';
        overlay.button.icon = 'send outline';
        overlay.cancelable = true;
        overlay.header.text = 'Send Agenda';
        overlay.buttonContainer.add(previewButton);
        var email;
        var contentView = app.request('build:messageTemplateEditor', {
          className: 'ui segment',
          model: messageTemplate,
          tags: tags,
          tagsAddressable: tagsAddressable
        }).listenTo(messageTemplate, 'preview', function (email) {
          var content = Templates.IRB['email.message'](email.toJSON());
          app.request('openEmailInPopup', {
            content: content,
            popup: popup,
            title: 'Meeting Agenda Preview'
          });
        }).listenTo(previewButton, 'press', function () {
          popup = app.request('pdf:popup');
          messageTemplate.preview({
            ownerId: meeting.id
          });
        });
        contentView.recipientsTokenInput.getOption('parent').required = true;
        Promise.join(messageTemplate.fetch()).then(function () {
          email = messageTemplate.toEmailMessage();
          return messageTemplate.clone().preview({
            email: email,
            ownerId: meeting.id
          });
        }).then(function () {
          messageTemplate.set(email.pick('recipients', 'cc', 'bcc'));
          tags.params({
            messageTemplateId: messageTemplate.id
          });
          return Promise.join(tags.fetch());
        }).then(function () {
          overlay.content.show(contentView);
          overlay.active = true;
          function sendLetter() {
            if (!messageTemplate._validate(null, {
              validate: true
            })) {
              return true;
            }
            return meeting.sendAgenda(messageTemplate.toEmailMessage()).promise().tap(function () {
              app.instantNotifications.add({
                icon: 'checkmark',
                iconColor: 'green',
                title: 'Agenda sent succesfully.'
              });
            });
          }
          contentView.listenTo(unsavedChangesModal, 'modal:show', function () {
            overlay.active = true;
          }).listenTo(unsavedChangesModal, 'save:model', function () {
            sendLetter();
          }).listenTo(overlay, 'save', function () {
            sendLetter();
          }).listenTo(messageTemplate, 'invalid', function () {
            overlay.active = true;
          }).listenTo(messageTemplate, 'sync', function () {
            overlay.active = false;
          }).listenToOnce(overlay, 'hidden', function () {
            changesHelper.off();
            unsavedChangesModal.stopListening();
            contentView.remove();
          });
          contentView.listenTo(overlay, 'leaving', function () {
            if (changesHelper.get('changes') == true) {
              overlay.active = true;
              accidentalCloseModal.visible = true;
            }
          }).listenTo(accidentalCloseModal, 'approve', function () {
            sendLetter();
          }).listenTo(accidentalCloseModal, 'deny', function () {
            overlay.active = false;
          });
        })["finally"](app.request('dimmer'));
        return overlay;
      });
      root.listenTo(pageModel, 'change:editing', onChangeEditing).listenTo(pageModel, 'change:canEdit', onChangeCanEdit).listenTo(pageModel, 'change:canMarkPresent', onChangeCanMarkPresent).listenTo(pageModel, 'change:canDelete', onChangeCanDelete).listenTo(meeting, 'change:startDate change:endDate', function () {
        root.boardDate.text = dateFormat(meeting.get('startDate'));
        root.boardTime.text = timeFormat(meeting.get('startDate')) + ' - ' + timeFormat(meeting.get('endDate'));
      }).listenTo(meeting, 'sync', function () {
        fullBoardTable._renderChildren();
      }).listenToOnce(meeting, 'sync', function () {
        root.viewAgenda.visible = true;
        root.viewMinutes.visible = true;
        var previousMeeting = meeting.get('lastMeetingId'),
          nextMeeting = meeting.get('nextMeetingId');
        if (previousMeeting) {
          this.previousMeetingButton.disabled = false;
          this.previousMeetingButton.link = RouteHelper.resolve('meeting:detail', {
            meetingId: previousMeeting
          });
        } else {
          this.previousMeetingButton.disabled = true;
        }
        if (nextMeeting) {
          this.nextMeetingButton.disabled = false;
          this.nextMeetingButton.link = RouteHelper.resolve('meeting:detail', {
            meetingId: nextMeeting
          });
        } else {
          this.nextMeetingButton.disabled = true;
        }
        this.listenTo(meeting.get('people'), 'change:present', _.debounce(function (meetingPerson, value, options) {
          meetingPerson.save().promise()["finally"](showTableLoading(attendeeTable));
        }));
      }).listenTo(meeting, 'change:startDate', function () {
        var startDate = meeting.get('startDate'),
          time = moment(startDate);
        meetingEditForm.meetingDate.value = startDate ? +moment(startDate).startOf('day') : startDate;
        meetingEditForm.startTime.value = startDate ? +moment().hour(time.hour()).minute(time.minute()) : startDate;
        updateBreadcrumb();
      }).listenTo(meeting, 'change:endDate', function () {
        var endDate = meeting.get('endDate'),
          time = moment(endDate);
        meetingEditForm.endTime.value = endDate ? +moment().hour(time.hour()).minute(time.minute()) : endDate;
      }).listenTo(meeting, 'change:group', _.debounce(function () {
        var board = meeting.get('group'),
          isEditing = pageModel.get('editing');
        if (!board) {
          return;
        }
        if (boardMembers) {
          boardMembers.params({
            id: board.id
          });
        } else {
          boardMembers = board.members({
            noAttributes: true
          });
          new LoaderHelper([boardMembers], {
            delay: 0
          }).on('change:loading', function () {
            var loading = this.get('loading');
            meetingEditForm.state = loading ? 'loading' : '';
            saveButton.disabled = loading ? loading : !changesHelper.get(ChangesHelper.UNSAVED_CHANGES);
          });
        }
        if (isEditing) {
          boardMembers.each(function (bm) {
            meeting.removePerson(bm.get('person'));
          });
          boardMembers.once('sync', function () {
            boardMembers.each(function (bm) {
              meeting.addPerson(bm.get('person'));
            });
          });
        }
        boardMembers.fetch();
      })).listenTo(meeting, 'error', function (model, err, options) {
        meetingEditForm.state = 'error';
        errorMessages.visible = true;
        errorMessages.collection.reset([{
          text: err instanceof Error ? String(err.message) : String(err)
        }]);
      }).listenTo(meeting, 'validated', function (isValid, model, invalidAttrs) {
        var errors = [];
        if (isValid) {
          return;
        }
        ;
        if (invalidAttrs.endDate) {
          errors.push({
            text: invalidAttrs.endDate
          });
        }
        if (invalidAttrs.startDate) {
          errors.push({
            text: invalidAttrs.startDate
          });
        }
        if (errors.length > 0) {
          errorMessages.visible = true;
          errorMessages.collection.reset(errors);
        }
      }).listenTo(meeting, 'sync', function () {
        meetingEditForm.state = '';
        addSubmissionButton.disabled = false;
        updatePermissions();
        updateNotesField();
        updateMeetingStatus();
        deleteButton.disabled = !!meeting.get('beginDate');
        updateMeetingStateBtns();
        if (root.finalizeMeeting.visible) {
          var decisions = meeting.get('documents').pluck('decision');
          root.finalizeMeeting.disabled = false;
          if (decisions.length > 0) {
            for (var d = 0, dLength = decisions.length; d < dLength; d++) {
              if (!decisions[d] || !decisions[d].get('finalizedDate')) {
                root.finalizeMeeting.disabled = true;
                break;
              }
            }
          }
        }
      }).listenTo(removedPersons, 'add remove reset', function () {
        undoRemovePersonButton.disabled = removedPersons.isEmpty();
      }).listenTo(removedDocuments, 'add remove reset', function () {
        undoRemoveSubmissionButton.disabled = removedDocuments.isEmpty();
      }).listenTo(changesHelper, 'change:' + ChangesHelper.UNSAVED_CHANGES, function () {
        saveButton.disabled = !changesHelper.get(ChangesHelper.UNSAVED_CHANGES);
      }).listenTo(unsavedModalEvents, 'save:model', function () {
        saveMeeting();
      });
      pageModel.set('editing', meeting.isNew());
      updatePermissions();
      this.permissionChecks();
      state.addPageDependencies([meeting, boards]).on('page:loaded', function () {
        region.show(root);
        changesHelper.reset();
      }).on('page:error', function () {
        app.navigate(RouteHelper.createLink('meeting:list').slice(1), {
          trigger: true
        });
        root.destroy();
      }).on('page:cancel', function () {
        root.destroy();
      });
      if (meeting.isNew()) {
        cancelButton.visible = false;
        topButtonSegment.visible = false;
        botttTabSegment.visible = false;
        var meetingDate = Number(state.get('date') || 'nope');
        meetingEditForm.meetingDate.value = meetingDate || null;
        meetingEditForm.startTime.value = +moment().hour(9).minute(0);
        meetingEditForm.endTime.value = +moment().hour(10).minute(0);
        root.listenToOnce(meeting, 'sync', function () {
          topButtonSegment.visible = true;
          botttTabSegment.visible = true;
          exemptDocuments.params({
            meetingId: meeting.id
          }).fetch();
          expeditedDocuments.params({
            meetingId: meeting.id
          }).fetch();
          fullExpeditedDocuments.params({
            meetingId: meeting.id
          }).fetch();
          closureDocuments.params({
            meetingId: meeting.id
          }).fetch();
          attachments.params({
            meetingId: meeting.id
          }).fetch();
          state.changeRouteName('meeting:detail').set({
            meetingId: meeting.id
          });
        }).listenToOnce(boards, 'sync', function () {
          syncDefaultBoardToMeeting();
          changesHelper.reset();
        });
        root.viewAgenda.visible = false;
        root.viewMinutes.visible = false;
        root.sendAgenda.visible = false;
      } else {
        attachments.params({
          meetingId: meeting.id
        }).fetch();
        exemptDocuments.fetch();
        expeditedDocuments.fetch();
        fullExpeditedDocuments.fetch();
        closureDocuments.fetch();
        meeting.fetch();
      }
      boards.fetch();
    },
    permissionChecks: function permissionChecks() {
      if (!this.userCanModifyMeeting()) {
        this.root.attachmentTable.columns.pop();
        this.root.attachmentTable.columns.last().unset('colspan');
      }
    },
    userCanModifyMeeting: function userCanModifyMeeting() {
      var authorityService = this.app.service('authority');
      return authorityService.userHasAuthority('PERM_MODIFY_MEETING');
    },
    userCanDeleteMeeting: function userCanDeleteMeeting() {
      var authorityService = this.app.service('authority');
      return authorityService.userHasAuthority('PERM_DELETE_MEETING');
    }
  });
  module.exports = MeetingDetailController;
});

